<div class="relative flex flex-col w-full h-full max-h-128">
  <button class="absolute top-0 right-0" mat-dialog-close="">
    <mat-icon class="text-secondary" svgIcon="heroicons_outline:x"></mat-icon>
  </button>

  <div class="text-2xl font-semibold tracking-tight text-center">
    {{ data ? 'Обновить файл' : 'Добавить документ' }}
  </div>

  <div class="flex flex-col gap-4 grow">
    <form class="flex flex-col gap-4" [formGroup]="formGroup">
      <div>
        <div *ngIf="!data">
          <com-form-label text="Тип" type="block" [required]="true"></com-form-label>
          <com-auto-suggestion
            class="basis-4/12"
            [clearable]="true"
            [options]="typeOptions$ | async"
            [form]="formGroup"
            (inputClick)="loadTypeOption$.next('')"
            (optionSelect)="typeSelect($event)"
            (optionRemove)="typeSelect(null)"
            controlName="type"
            placeholder="Выберите значение"
          ></com-auto-suggestion>
        </div>
        <div>
          <com-form-label text="Файл" type="block" [required]="true"></com-form-label>
          <com-form-file-upload
            [control]="formGroup.controls.fileData"
            [acceptFile]="acceptFile$ | async | joinString"
            [disabled]="formGroup.controls.fileData.disabled"
          ></com-form-file-upload>
        </div>
      </div>
      <div class="flex items-center justify-center sm:justify-end gap-4">
        <button mat-stroked-button mat-dialog-close="">Отмена</button>
        <button mat-flat-button color="primary" [disabled]="formGroup.invalid" (click)="confirm()">
          Подтвердить
        </button>
      </div>
    </form>
  </div>
</div>
